import { makeStyles, tokens } from "@fluentui/react-components";

export const useStyles = makeStyles({
  drawer: {
    backgroundColor: tokens.colorNeutralBackground1,
    "& button, & a": {
      backgroundColor: "transparent",
    },
  },
  userInfo: {
    display: "flex",
    alignItems: "center",
    gap: "10px",
    padding: "8px 12px",
    marginTop: "8px",
    color: tokens.colorNeutralForeground1,
    fontSize: tokens.fontSizeBase300,
    overflow: "hidden",
    "& span": {
      overflow: "hidden",
      textOverflow: "ellipsis",
      whiteSpace: "nowrap",
    },
  },
  divider: {
    marginTop: "8px",
    marginBottom: "8px",
  },
  copyright: {
    display: "block",
    padding: "12px 12px 4px",
    fontSize: tokens.fontSizeBase100,
    color: tokens.colorNeutralForeground3,
    textAlign: "left",
    alignSelf: "flex-start",
    width: "100%",
  },
});
